export default {
    title: "News",
    followUsLabel: "Follow us",
    loadingLabel: "Loading...",
    scrollMoreLabel: "Scroll for more",
  }